var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("MMP_GTP_Tracking_ReportModal", {
        attrs: { gtpColumns: _vm.gtpColumns, gtpRows: _vm.gtpRows },
        on: {
          showDetailsModal: function ($event) {
            return _vm.$bvModal.show("detailsModal")
          },
          updatedCoordinates: function ($event) {
            return _vm.updateCoordinates($event)
          },
          updatedGTPDetailsRows: function ($event) {
            _vm.gtpDetailsRows = $event
          },
        },
      }),
      _vm._v(" "),
      _c("MMP_GTP_Tracking_DetailsModal", {
        attrs: {
          gtpDetailsRows: _vm.gtpDetailsRows,
          lat: _vm.lat,
          long: _vm.long,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }